/**
 * scroll.js — Smooth scroll with sticky/fixed header offset
 */

/** Calculate total height of fixed/sticky headers */
export function getTopOffset() {
	const selectors = [
		"#wpadminbar",
		".site-header",
		'header[role="banner"]',
		".wp-block-template-part header",
		".edit-post-header",
		".interface-interface-skeleton__header",
	];
	let h = 0;
	selectors.forEach((sel) => {
		const el = document.querySelector(sel);
		if (!el) return;
		const cs = getComputedStyle(el);
		const fixedish = cs.position === "fixed" || cs.position === "sticky";
		const isTop0 = (cs.top || "0").toString().startsWith("0");
		if (fixedish && isTop0) h += el.offsetHeight || 0;
	});
	return h + 12; // breathing space
}

/** Scroll smoothly to an element, accounting for fixed headers */
export function smoothScrollTo(el, extra = 0) {
	if (!el) return;
	const rect = el.getBoundingClientRect();
	const y = window.pageYOffset + rect.top - getTopOffset() - (extra || 0);
	window.scrollTo({ top: y, behavior: "smooth" });
}
